import { render, staticRenderFns } from "./VentureCard.vue?vue&type=template&id=f0c79a60&scoped=true"
import script from "./VentureCard.vue?vue&type=script&lang=js"
export * from "./VentureCard.vue?vue&type=script&lang=js"
import style0 from "./VentureCard.vue?vue&type=style&index=0&id=f0c79a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c79a60",
  null
  
)

export default component.exports